import "./scripts/carousel";
import "./scripts/home";
import "./scripts/instagram";

import "./styles/carousel.scss";
import "./styles/featurettes.scss";
import "./styles/home.scss";
